import React from 'react';

// Components
import EmptyStateContainer from 'Shared/components/EmptyStateContainer/EmptyStateContainer';

const QuestionLeftUnanswered = () => {
  return <EmptyStateContainer subTitle="No response submitted" grayBackground inContainer padding="025" />;
};

export default QuestionLeftUnanswered;
